import { applyMiddleware,createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "../reducers/index";
import createSagaMiddleware from "redux-saga";
import {rootSaga} from "../sagas"

const sagaMiddleware = createSagaMiddleware();


let store = null
if(process.env.REACT_APP_BACKEND_MODE==="LOCAL"||process.env.REACT_APP_BACKEND_MODE==="DEV"){
    store = createStore(rootReducer, 
        composeWithDevTools( applyMiddleware(sagaMiddleware)));
}else{
    store = createStore(rootReducer, 
        applyMiddleware(sagaMiddleware));
}
    

sagaMiddleware.run(rootSaga)    
export default store;